import { SOCKET } from './types';

export const connectSocket = () => {
  return {
    type: SOCKET.CONNECT
  };
};

export const disconnectSocket = () => {
  return {
    type: SOCKET.DISCONNECT
  };
};

export const subscribeTaskListSocket = () => {
  return {
    type: SOCKET.SUBSCRIBE_TASK_LIST
  };
};

export const subscribeTaskDetailSocket = (payload) => {
  return {
    type: SOCKET.SUBSCRIBE_TASK_DETAIL,
    payload
  };
};
